import { ComponentPropsWithoutRef } from 'react';
import { StyledButtonGroup } from './styles';

export const ButtonGroup = ({ children }: ComponentPropsWithoutRef<'div'>) => {
    return <StyledButtonGroup>{children}</StyledButtonGroup>;
};
